import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';

const stats = [
  { value: '231', label: 'кейсов из разных ниш', accent: false },
  { value: '240+', label: 'сообществ продвинули', accent: true },
  { value: '96%', label: 'клиентов продлевают', accent: false },
];

export default function CasesHero() {
  return (
    <section className="relative w-full px-5 md:px-10 pt-16 md:pt-20 pb-16 md:pb-20">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          label="Кейсы"
          title="Реальные проекты и результаты в цифрах"
          description="Показываем, как сообщества растут на практике: какие задачи решали, какие инструменты подключали и к каким метрикам пришли. Без обещаний — только факты и цифры."
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          {stats.map((stat, index) => (
            <Reveal key={stat.label} delay={index * 90}>
              <div className="h-full flex flex-col items-center justify-center p-6 md:p-7 rounded-lg bg-background-100/70 border border-background-200/70">
                <span
                  className={`font-heading font-bold text-3xl md:text-4xl ${
                    stat.accent ? 'text-accent-500' : 'text-primary-500'
                  }`}
                >
                  {stat.value}
                </span>
                <span className="mt-2 text-sm text-foreground-600 text-center">{stat.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}